import React from 'react';
import { useCheckboxStyles } from 'components/UI/V2/Forms/Checkbox/Checkbox.styles';
import { Label } from 'components/UI/V2/Forms/Label/Label';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

type CheckboxProps = Omit<React.ComponentProps<'input'>, 'onChange'> & {
    error?: string;
    label?: string;
    className?: string;
    inlineLabel?: string;
    description?: string;
    onChange?: (checked: boolean) => void;
};

export const Checkbox: React.FC<CheckboxProps> = ({
    error,
    label,
    className,
    inlineLabel,
    description,
    ...inputProps
}) => {
    const classes = useCheckboxStyles();

    return (
        <div
            className={clsx(classes.root, className)}
            onClick={() => inputProps.onChange?.(!inputProps.checked)}
        >
            {label && <Label error={error}>{label}</Label>}

            <div className={classes.optionContainer}>
                <div className={classes.radioContainer}>
                    <input
                        type="checkbox"
                        {...inputProps}
                        checked={inputProps.checked}
                        className={classes.input}
                        onChange={event => inputProps.onChange?.(event.target.checked)}
                    />

                    {inlineLabel && <Typography className={classes.optionLabel}>{inlineLabel}</Typography>}
                </div>

                {description && <Typography className={classes.optionDescription}>{description}</Typography>}
            </div>
        </div>
    );
};
